/*
 * GENERATED — do not edit manually. Run: pnpm gen:components
 * Source: packages/ui-theme/contracts/modal.contract.json
 * Styles: @indipia/styles/components.css (토큰 구동 의미 클래스)
 */
import React, { useRef, useId } from 'react';
import { cx } from '../cx';
import { useDialog } from '../useDialog';

export interface ModalProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  /** 자동 닫힘 진행바 — 남은 비율 0~1. 생략하면 진행바를 그리지 않는다 */
  progress?: number;
  /** 버튼 영역 — .modal-foot(우측 정렬·gap-sm·사방 spacing-05)로 감싸 본문 밑에 그린다. 버튼 크기는 공통 규칙(base)으로 통일 */
  footer?: React.ReactNode;
  /** 버튼 배치 — end: 우측 정렬·내용폭(기본) / stretch: 균등폭 */
  footerAlign?: 'end' | 'stretch';
  children: React.ReactNode;
}

/** 0~1 밖 값이 와도 띠가 넘치거나 음수 폭이 되지 않게 자른다 */
const clampRatio = (v: number) => Math.min(1, Math.max(0, v));

export function Modal({ open, onClose, title, size = 'md', progress, footer, footerAlign = 'end', children, className = '', ...props }: ModalProps) {
  const boxRef = useRef<HTMLDivElement>(null);
  const titleId = useId();

  // 포커스 트랩·Esc·포커스 복원·겹침 처리·바깥 클릭 닫기 (D-09 §15.6, Drawer와 동일 훅)
  const { scrimProps } = useDialog(open, onClose, boxRef);

  if (!open) return null;

  return (
    <div
      className={cx('scrim', 'show', size === 'full' && 'scrim-full')}
      {...scrimProps}
    >
      <div
        className={cx('modal-box', size !== 'md' && `modal-${size}`, className)}
        {...props}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        tabIndex={-1}
        ref={boxRef}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="modal-head">
            <h4 id={titleId}>{title}</h4>
            <button className="x" onClick={onClose} aria-label="닫기">×</button>
          </div>
        )}
        {progress != null && (
          <div
            className="modal-progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(clampRatio(progress) * 100)}
          >
            <span style={{ width: `${clampRatio(progress) * 100}%` }} />
          </div>
        )}
        <div className="modal-body">{children}</div>
        {footer && <div className={cx('modal-foot', footerAlign === 'stretch' && 'modal-foot-stretch')}>{footer}</div>}
      </div>
    </div>
  );
}
